/*eslint-disable */
import React, { useState, useEffect, useRef  } from "react";
import {
  Button,
  Modal,
} from "semantic-ui-react";
import {
  successAlertDispatcher,
  errorAlertDispatcher,
} from "../../redux/actions/alertAction";
import { Form, TextArea } from 'semantic-ui-react'
import { Form as Formiker, Field, withFormik, ErrorMessage } from "formik";
import * as Yup from "yup";
import ReadAxios from "../axiosComponent/read";
import { translate } from "react-i18next";
import { isEmpty, values } from "lodash";
import CreateAxios from "../axiosComponent/create";
import { connect } from "react-redux";

const RebidModal = (props,{ values, errors, touched, isSubmitting }) => {

  const { t } = props;
  
  return (
    <React.Fragment>
    <Modal
      open={props.OpenModal}
      size="mini"
      centered={true}
      scrolling="true"
      onClose={props.CloseModal}
    >
      <Modal.Header>
      <div className="d-flex justify-content-between">
          <label className="mt-2 font-weight-normal">{t("title") || "Rebid"}</label>
          <div className="form-inline">
              <i onClick={props.CloseModal} className="fas fa-times"></i>
          </div>
      </div>
      </Modal.Header>
      <Modal.Content>
      <Formiker>
          <Field 
          name="message" 
          className="form-control" 
          component="textarea"
          placeholder={t("placeholder") || 'Enter Message'} />
          <ErrorMessage name= "message" />
          <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }} >
            <Button
              type="submit"
              // onClick={props.rebidonSubmit}
              size="mini"
              disabled = {isSubmitting}
              className="w3-blue w3-round w3-hover-blue"
              style={{ marginTop:"20px", textAlign: "center" }}
            >
              {t("submit") || "Submit"}
            </Button>
          </div>
      </Formiker>
      </Modal.Content>
      
    </Modal>
    </React.Fragment>
  );
};

const FormikRebid = withFormik({
  mapPropsToValues( {message} ) {
    return {
      message: message || "",
    };
  },
  validationSchema: Yup.object().shape({
    message: Yup.string().required("message Required"),
  }),
  handleSubmit(values, { setErrors, setSubmitting, props}) {
    console.log(props);
    console.log(values);
    // getValue(values.message)
    props.rebidonSubmit
    props.textareaValue(values.message)
  },
})(RebidModal);

export default connect(null, { successAlertDispatcher, errorAlertDispatcher })(translate("rebid")(FormikRebid));
